<template>
  <div class="pa-2">
    <v-tabs v-model="tab" color="indigo accent-4" grow>
      <v-tab v-for="item in TabsName" v-if="checkPermissions(item.permission)" :key="item.name"
             class="text-center text-info font-weight-bold" @change="getVal(item.value)">
        <i class="fa fa-plus ml-2 text-info"></i>
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in myComponents" v-if="checkPermissions(item.permission)" :key="item.value">
        <component :is="item.name"
                   v-if="activeComponent === item.value && checkPermissions(item.permission)" :key="item.name"
                   :de-active="false"/>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import GraduaShop from "../ladderShop/GraduaShop";
import GradualLadder from "../ladder/GradualLadder";
import GradualLadders from "../ads/panels/ladder/gradualLadder";
import CarGradual from "../ads/panels/ladder/carGradual.vue";
import ExpertGradualLadders from "../ads/panels/ladder/expertLadder";
import {mapGetters} from "vuex";

export default {
  name: "gradualComponents",

  components: {GradualLadders, GradualLadder, GraduaShop, ExpertGradualLadders, CarGradual},

  data() {
    return {
      myComponents: [
        {
          name: 'gradual-ladder',
          value: 'simpleGradual',
          permission: 'gradual_store:active'
        },
        // {
        //   name: 'ExpertGradualLadders',
        //   value: 'serviceGradual',
        //   permission: 'gradual_service:active'
        // },
        {
          name: 'gradua-shop',
          value: 'shopGradual',
          permission: 'gradual_store_shop:active'
        },
        {
          name: 'gradual-ladders',
          value: 'estateGradual',
          permission: 'gradual_store_estate:active'
        },
        {
          name: 'carGradual',
          value: 'carGradual',
          permission: 'gradual_store_car:active'
        }
      ],
      TabsName: [
        {
          name: 'نردبان تدریحی شخصی',
          value: 'simpleGradual',
          permission: 'gradual_store:active'
        },
        // {
        //   name: 'نردبان تدریحی متخصص',
        //   value: 'serviceGradual',
        //   permission: 'gradual_store_menu:active'
        // },
        {
          name: 'نردبان تدریجی فروشگاهی'
          , value: 'shopGradual',
          permission: 'gradual_store_shop:active'
        },
        {
          name: 'نردبان تدریجی املاک'
          , value: 'estateGradual',
          permission: 'gradual_store_estate:active'
        },
        {
          name: 'نردبان تدریجی نمایشگاه',
          value: 'carGradual',
          permission: 'gradual_store_car:active'
        }
      ],
      tab: '',
      activeComponent: ''
    }

  },

  mounted() {
    this.checkComponent();
  },

  computed: {
    ...mapGetters(['currentAbilities']),
  },

  methods: {
    getVal(val) {
      this.activeComponent = val
    },
    checkPermissions(value) {
      return Boolean(this.currentAbilities.find((x) => x === value))
    },
    checkComponent() {
      this.myComponents.every((x) => {
        if (this.currentAbilities.find((perm) => perm === x.permission)) {
          this.activeComponent = x.value
          return false;
        }
        return true;
      })
    }
  }
}
</script>

<style scoped>

</style>